<template>
  <div>
    <vs-table stripe
		:data="docList"
		class="mt-4"
		noDataText="Pas de document."
    >
      <template slot="thead">
        <vs-th class="bgcolor white-txt">Type</vs-th>
        <vs-th class="bgcolor white-txt">Nom du fichier</vs-th>
        <vs-th class="bgcolor white-txt"><vs-spacer />Lien<vs-spacer /></vs-th>
        <vs-th class="bgcolor white-txt"></vs-th>
        <vs-th class="bgcolor white-txt"></vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(row, index) in data">
          <vs-td :id="'type' + row.id" v-if="refresh != row.id">{{ typeList.filter(type => type.id == row.contract_document_type_id)[0].type_name }}</vs-td>
          <vs-td :id="'name' + row.id" v-if="refresh != row.id">{{ row.filename }}</vs-td>
          <vs-td :id="'link' + row.id" v-if="refresh != row.id">
			<vx-tooltip :text="row.link" position="top" style="text-align: -webkit-center; margin-right: 0 !important;">
				<a :href="row.link" target="_blank">
					<vs-button
						size="large"
						color="primary"
						type="flat"
						icon-pack="feather"
						icon="icon-external-link"
						@click="() => {pass;}"
					></vs-button>
				</a>
			</vx-tooltip>
			</vs-td>
          <vs-td v-if="!row.editmode">
			<vx-tooltip text="Modifier" position="top" style="text-align: -webkit-center; margin-right: 0 !important;">
				<vs-button
					size="large"
					color="primary"
					type="flat"
					icon-pack="feather"
					icon="icon-edit"
                    @click="row.editmode=true;$forceUpdate();updateDoc(row)"
				/>
            </vx-tooltip>
			</vs-td>
          <vs-td v-if="!row.editmode">
			<vx-tooltip text="Effacer" position="top" style="text-align: -webkit-center; margin-right: 0 !important;">
				<vs-button
					size="large"
					color="danger"
					type="flat"
					icon-pack="feather"
					icon="icon-trash-2"
					@click="displayValidationPopup(row.id)"
				></vs-button>
            </vx-tooltip>
			</vs-td>
          <vs-td v-if="row.editmode">
			<vx-tooltip text="Enregistrer" position="top" style="text-align: -webkit-center; margin-right: 0 !important;">
				<vs-button
					size="large"
					color="primary"
					type="flat"
					icon-pack="feather"
					icon="icon-save"
                    @click="saveDoc(row.id)"
				/>
            </vx-tooltip>
			</vs-td>
          <vs-td v-if="row.editmode">
			<vx-tooltip text="Annuler" position="top" style="text-align: -webkit-center; margin-right: 0 !important;">
				<vs-button
					size="large"
					color="danger"
					type="flat"
					icon-pack="feather"
					icon="icon-x"
					@click="cancelEdit(row.id)"
				></vs-button>
            </vx-tooltip>
			</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";
import VueCookies from "vue-cookies";

export default {
	name: "ContractDocumentsTable",
	components: {
	},
	props: {
		contract_documents: Array,
		typeList: Array
	},
	mixins: [dbFieldConvertor, utilsMixin],
	computed: {
		activeUser(){
			return VueCookies.get("userInfo");
		}
	},
	data() {
		return {
			apiUrl: store.state.backendApiUrl,
			docList: [],
			refresh: "refresh"
		};
	},
	created() {
		this.docList = this.$props.contract_documents;
		for(let i = 0; i < this.docList.length; i++){
			this.docList[i]["editmode"] = false;
		}
	},
	watch: {
		contract_documents: function(data){
			this.docList = data;
			for(let i = 0; i < this.docList.length; i++){
				this.docList[i]["editmode"] = false;
			}
		}
	},
	methods: {
		updateDoc(doc){
			document.getElementById("name" + doc.id).innerHTML = `<input placeholder="Nom du document" id="docName${doc.id}" value="${doc.filename}"/>`;

			document.getElementById("type" + doc.id).innerHTML = `<select id="docType${doc.id}"></select>`;

			for(let i = 0; i < this.typeList.length; i++){
				document.getElementById("docType" + doc.id).options.add(new Option(this.typeList[i].type_name, this.typeList[i].id));
				if(this.typeList[i].id == doc.contract_document_type_id) document.getElementById("docType"+ doc.id).options[i].selected = true;
			}

			document.getElementById("link" + doc.id).innerHTML = `<input placeholder="Link" id="docLink${doc.id}" value="${doc.link}"/>`;
		},
		cancelEdit(id){
			for(let item of this.docList){
				if(item.id == id) {
					this.refresh = id;
					this.$nextTick(() => {
						item.editmode = false;
						this.refresh = "refresh";
					});
					return;
				}
			}
		},
		saveDoc(docId){
			let regex = /^(?:ftp|http|https):\/\/(?:[\w\.\-\+]+:{0,1}[\w\.\-\+]*@)?(?:[a-z0-9\-\.]+)(?::[0-9]+)?(?:\/|\/(?:[\w#!:\.\?\+=&%@!\-\/\(\)]+)|\?(?:[\w#!:\.\?\+=&%@!\-\/\(\)]+))?$/;
			let errText = "";

			if(document.getElementById("docName" + docId).value == "") errText+= "Le nom du document ne peut être vide.\n";
			if(document.getElementById("docLink" + docId).value == "") errText+= "Le lien ne peut être vide.\n";
			if(!regex.test(document.getElementById("docLink" + docId).value) && document.getElementById("docLink" + docId).value !== "") errText+= "Le lien saisi n'est pas valide. (Préfixes: ftp/http/https)";

			if(errText !== ""){
				this.$vs.notify({
					title: "Erreur",
					text: errText,
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "warning"
				});
			}
			else{
				for(let item of this.docList){
					if(item.id == docId) {
						this.refresh = docId;
						item.filename = document.getElementById("docName" + docId).value
						item.contract_document_type_id = document.getElementById("docType" + docId).value
						item.link = document.getElementById("docLink" + docId).value
						this.$nextTick(() => {
							item.editmode = false;
							this.refresh = "refresh";
						});
						return;
					}
				}
			}
		},
		displayValidationPopup(docId){
			this.docList.splice(this.docList.findIndex(doc => doc.id == docId), 1)
		},
	}
};
</script>

<style scoped>
</style>
